import StopScroll from "./StopScrollClass";
import FilterProducts from "./filter/FilterProductsClass";

export default class Catalog {

    static initial() {
        //Filter
        this.valueRange();
        this.checkboxAction();
        this.clearFromSelect();

        //Other functions
        this.sortingFilters();
        this.swipeFilter();

        this.stopScroll = null;

        //Filter products
        let argFilter = {
            container: '.catalog_wrap',
            filterUrl: filterRoute.url,
            fastFiltersCl: '.big_sorting--sorting li[data-f], .catalog_mob_filter .select_content li[data-f]',
            rangeFiltersCl: '.value_ranges button[type="button"]',
            optionsFiltersCl: '#special_option input',
            filtersCl: '.catalog_filter .filter_block:not(#special_option) :checkbox',
            changeViewCl: '.big_sorting--structure li',
            params: filterParams
        };
        this.filterPr = new FilterProducts(argFilter);
    }


    /**
     *
     */
    static valueRange() {
        let $this = this,
            $valueRanges = $('.value_ranges');

        if($valueRanges.length) {
            $valueRanges.find('button').on('click', function () {
                let $btnFrom = $(this).siblings('.inputs').find('input.from'),
                    $btnTo = $(this).siblings('.inputs').find('input.to'),
                    dataType = $(this).parent().attr('data-type'),
                    dataId = $(this).parent().attr('data-id');

                let valueFrom = Number($btnFrom.val()),
                    valueTo = Number($btnTo.val()),
                    valueMinFrom = Number($btnFrom.attr('min')),
                    valueMaxTo = Number($btnTo.attr('max'));

                //Skip if the same
                if(valueFrom === valueMinFrom && valueTo === valueMaxTo) return;

                if(valueFrom < valueTo && valueFrom >= valueMinFrom && valueTo <= valueMaxTo) {
                    $btnFrom.removeClass('error');
                    $btnTo.removeClass('error');

                    //push
                    let filterValue = valueFrom + ' - ' + valueTo + ' ' + dataType;
                    $this.puhToSelect(filterValue, dataId, 'range_value');

                } else {
                    $btnFrom.addClass('error');
                    $btnTo.addClass('error');
                }

            });
        }
    }

    /**
     *
     */
    static checkboxAction() {
        let $this = this,
            $checkbox = $('.catalog_filter .checkbox');

        if($checkbox.length) {
            $checkbox.find('input[type="checkbox"]').on('change', function () {
                let id = $(this).attr('id');
                if($(this).prop('checked')) {
                    let value = $(this).siblings('label').find('p').html();
                    $this.puhToSelect(value, id);
                } else {
                    $this.removeFromSelect(id);
                }
            });
        }
    }

    /**
     *
     */
    static clearFromSelect() {
        let $this = this;

        $('.catalog_content').on('click', '#selected_filter li .icon-clear', function () {
            let dataID = $(this).parent().attr('data-id');

            if($(this).parent().hasClass('range_value')) {
                //Reset data for vale range
                let $blockRange = $('div[data-id="'+ dataID +'"]');

                $blockRange.find('input.from').val($blockRange.find('input.from').attr('min'));
                $blockRange.find('input.to').val($blockRange.find('input.to').attr('max'));

                $this.removeFromSelect(dataID);

                //Trigger apply
                $blockRange.find('button[type="button"]').trigger('click');
            } else {
                //Reset data for checkbox
                $('input#' + dataID).trigger('click');
            }
        });
    }


    /**
     * @param value String
     * @param id String
     * @param classCustom String
     */
    static puhToSelect(value, id, classCustom = '') {
        let $filtersArea = $('#selected_filter');

        //Remove the same values
        //Like price range
        $filtersArea.find('li[data-id='+ id +']').remove();

        //Set new
        let li = '<li data-id="'+ id +'" class="'+ classCustom +'">'+ value +'<i class="icon icon-clear"></i></li>';
        $filtersArea.append(li);

        //Show|Hide filter
        if($filtersArea.find('li').length) {
            $filtersArea.parent().show();
        } else {
            $filtersArea.parent().hide();
        }
    }

    /**
     * @param id
     */
    static removeFromSelect(id) {
        let $filtersArea = $('#selected_filter');
        $filtersArea.find('li[data-id='+ id +']').remove();

        //Show|Hide filter
        if($filtersArea.find('li').length) {
            $filtersArea.parent().show();
        } else {
            $filtersArea.parent().hide();
        }
    }

    /**
     * Sorting product for desktop & mobile
     */
    static sortingFilters() {
        //Desktop
        if($(window).width() >= 1200) {
            let $bigSorting = $('.big_sorting--sorting');
            $bigSorting.on('click', 'li:not(.active):not(.title)', function () {
                $(this).siblings('li').removeClass('active');
                $(this).addClass('active');
            })
        }

        //Mobile
        if($(window).width() < 1200) {
            let $selectFilter = $('.catalog_header .filter_select');
            $selectFilter.on('click', '.btn', function (e) {
                e.preventDefault();

                $(this).toggleClass('open');

                //Outside close
                if($(this).hasClass('open')) {
                    outSelectClick(true, $selectFilter);
                } else {
                    outSelectClick(false);
                }
            });

            //Select li
            $selectFilter.on('click', '.select_content li:not(.active)', function () {
                $(this).siblings('li').removeClass('active');
                $(this).addClass('active');

                $(document).trigger('click.out.filter.catalog');
            });
        }

        function outSelectClick(status, $element) {
            if(status) {
                $(document).bind('click.out.filter.catalog', function (e) {
                    if (!$element.is(e.target) && $element.has(e.target).length === 0) {
                        $element.find('.btn').removeClass('open');
                        outSelectClick(false);
                    }
                })
            } else {
                $(document).unbind('click.out.filter.catalog');
            }
        }
    }

    /**
     * Open|close filter on mobile devises
     */
    static swipeFilter() {
        let $this = this,
            $swipePopups = $('.open_swipe_filter'),
            $overlayPage = $('.overlay_page'),
            $wrapSlide = $('#xhr-filter');

        if($(window).width() < 1200) {
            //open
            $swipePopups.on('click', function (e) {
                e.preventDefault();
                let id = $(this).attr('data-swipe');

                if (!id) {
                    console.warn('Please set data-swipe|data-step attribute');
                    return false;
                }

                $wrapSlide.css({transform: 'translate(-100%, 0)'});
                $(id).css({transform: 'translate(0, 0)'});
                $overlayPage.fadeIn(200);
                setCloseOverlay(true);

                //Stop scroll
                $this.stopScroll = new StopScroll($(id), '.catalog_filter', '.catalog_filter');
                $this.stopScroll.disableScroll();
            });

            //Close filter
            $('.catalog_filter').on('click', '.close-filter a', function (e) {
                e.preventDefault();
                $overlayPage.trigger('click.filter.mobile');
            })
        }

        function setCloseOverlay(set) {
            if(set) {
                $overlayPage.bind('click.filter.mobile', function () {
                    allClose()
                });
            } else {
                $overlayPage.unbind('click.filter.mobile');
            }
        }

        function allClose() {
            $wrapSlide.css({transform:'translate(-100%, 0)'});
            $overlayPage.fadeOut(100);
            setCloseOverlay(false);
            $this.stopScroll.enableScroll();
        }
    }

}
